export default __webpack_public_path__ + "static/media/014-chemical analysis.27640f21.svg";